import { useState } from 'react';
import { Modal, ModalType } from '@ukpostbox/frontend-framework';
import { MultiSendsUpload } from '../../../ProfilesUser/Components/MultiSendsUpload';
import { SendDataProcessType } from '../../Types/SendsFormTypes';

interface SendUploadModalType extends ModalType {
	sendData: SendDataProcessType;
	uploadStartedCallback?: any;
	saveSendStartedCallback?: any;
}

function SendMultipleProcessingWizardModal(props: SendUploadModalType) {
	const [locked, setLocked] = useState<boolean>(true);

	return (
		<Modal title='Send Items' lockOpen={locked} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
			<MultiSendsUpload
				name='multiSends'
				onError={(e) => console.log(e)}
				closeCallback={() => props.closeCallback()}
				queueStatusCallback={(state) => setLocked(state)}
				sendData={props.sendData}
				acceptsFileExtension={['.pdf']}
				extensionDisplayValue='PDF'
				maxFiles={50}
			/>
		</Modal>
	);
}

export default SendMultipleProcessingWizardModal;
